import type { ILandingSite, ILandingTemplate } from '@/entities/landing.entity';

export const PHOTO_TEMPLATE_SLUG = 'photo';

export function templateRequiresSiteMode(
	template: ILandingTemplate | undefined,
	templateSlug: string,
): boolean {
	if (template?.source === 'custom') {
		return template.templateKind !== 'telegram_auth';
	}
	if (template?.siteConfig?.mode?.required) {
		return true;
	}
	return templateSlug === PHOTO_TEMPLATE_SLUG || template?.slug === PHOTO_TEMPLATE_SLUG;
}

export function isTelegramAuthCustomTemplate(template: ILandingTemplate | undefined): boolean {
	return template?.templateKind === 'telegram_auth';
}

const CUSTOM_TELEGRAM_AUTH_SLUG_PREFIX = 'custom-ta-';

export function isTelegramAuthLandingTemplate(
	template: ILandingTemplate | undefined,
	templateSlug: string,
): boolean {
	if (templateSlug === 'telegram-auth') {
		return true;
	}
	if (templateSlug.startsWith(CUSTOM_TELEGRAM_AUTH_SLUG_PREFIX)) {
		return true;
	}
	return isTelegramAuthCustomTemplate(template);
}

export function isTelegramSite(site: ILandingSite | undefined): boolean {
	return site?.config?.mode === 'telegram';
}

export function pickDefaultSiteId(sites: ILandingSite[], readyBuildCount: number): string | null {
	if (sites.length === 0) {
		return null;
	}
	if (readyBuildCount === 0) {
		const telegramSite = sites.find(isTelegramSite);
		if (telegramSite) {
			return String(telegramSite.id);
		}
	}
	return String(sites[0].id);
}
